export const RESIZE_DEBOUNCE_TIME_MS = 35;